import React from 'react'; // 

import { SiOpenaigym } from 'react-icons/si';


export const programs = [
    {
        id: 1,
        icon: <SiOpenaigym />,
        title: "Reference",
        info: "Discover reference!",
        path: "/service"
    },
    
];

export const values = [
    {
        id: 1,
        icon: <SiOpenaigym />,
        title: "Video",
        desc: "Interview for entry level position.",
        path: "/values/111"
    },
    
];
export const faqs = [
    {
        id: 1,
        question: "How does the video interview process work?",
        answer: "Our platform streamlines hiring with structured video references: (1) Submit candidate details, (2) Candidate completes pre-screening video, (3) Request references from previous employers, (4) Review all video submissions, (5) Make confident hiring decisions."
    },
    {
        id: 2,
        question: "How do I submit a candidate for video interviews?",
        answer: "From your dashboard, click 'Candidate Request' to submit candidate details. You'll need their name, email, and position information. The candidate will then receive automated invitations to complete their video interviews."
    },
    {
        id: 3,
        question: "What types of video interviews are available?",
        answer: "We support two interview types: (1) Pre-screening interviews where candidates answer your questions, and (2) Reference interviews where previous employers provide verified feedback about the candidate's work."
    },
    {
        id: 4,
        question: "When can I request reference interviews?",
        answer: "The 'Request References' button becomes available after a candidate completes their pre-screening interview. This initiates automated requests to their previous employers for reference videos."
    },
    {
        id: 5,
        question: "How long do candidates have to complete interviews?",
        answer: "Candidates typically have 7 days to complete pre-screening interviews. Reference providers have 10 days to submit their feedback videos. You'll receive notifications as each video is submitted."
    },
    {
        id: 6,
        question: "Can I customize the interview questions?",
        answer: "Yes! For pre-screening interviews, you can select from our question library or create custom questions. Reference interviews use standardized questions designed to elicit meaningful feedback about past performance."
    },
    {
        id: 7,
        question: "How secure are the video submissions?",
        answer: "All videos are encrypted in transit and at rest. Access is strictly controlled - only authorized hiring team members can view submissions. Videos are automatically deleted after 90 days unless archived."
    },
    {
        id: 8,
        question: "What if a reference provider doesn't respond?",
        answer: "Our system automatically sends 3 reminders. If there's no response after 10 days, you'll be notified and can either extend the deadline or request an alternative reference."
    },
    {
        id: 9,
        question: "Can candidates review their videos before submitting?",
        answer: "Yes, candidates can practice and re-record their answers before final submission. However, once submitted, videos cannot be modified to ensure authenticity."
    },
    {
        id: 10,
        question: "How do I compare multiple candidates?",
        answer: "Our dashboard lets you side-by-side compare candidate videos, with tools to bookmark key moments, add private notes, and share clips with your hiring team."
    }
];


export const testimonials = [
    {
        id: 1,
        name: "Sarah Johnson",
        quote: "This platform cut our hiring time in half. The video references gave us genuine insights we'd never get from written references alone.",
        job: "HR Director",
        avatar: require("./images/avatar1.jpg")
    },
    {
        id: 2,
        name: "Michael Chen",
        quote: "The automated reference requests saved us countless hours of phone tag. We now get 3x more references than with our old process.",
        job: "Talent Acquisition",
        avatar: require("./images/avatar2.jpg")
    },
    {
        id: 3,
        name: "David Rodriguez",
        quote: "Seeing candidates answer questions in their own words revealed communication skills we'd miss in traditional screenings.",
        job: "Department Manager",
        avatar: require("./images/avatar3.jpg")
    },
    {
        id: 4,
        name: "Latifa Wilson",
        quote: "Reference videos helped us spot several 'perfect' candidates who exaggerated their accomplishments. Worth every penny.",
        job: "Startup Founder",
        avatar: require("./images/avatar4.jpg")
    },
    {
        id: 5,
        name: "Janet Thompson",
        quote: "Our bad hires dropped by 40% since implementing video references. The depth of feedback is game-changing.",
        job: "Operations VP",
        avatar: require("./images/avatar5.jpg")
    }
];
